export enum AnalyticsEventGroup {
  MERCHANT = 'merchant',
  CLIENT = 'client',
  PAGE = 'page',
}
